<div class="ft-image-div podium-photo" [style.background-image]="backgroundImage()" [hidden]="!isVisible">
    <div class="photo-matte"></div>
    <!-- gapless: v1 ftPodiumPhoto built this from a concatenated template string with NO
         text nodes between children; whitespace here shifts the centered .icon glyph. -->
    <div class="podium-photo-board"><div class="icon"></div><span class="caption">@if (captionType()) {<div class="winner-slot-caption-{{ captionType() }}">{{ captionLabel() }}</div>}</span></div>
    @if (isMenuVisible()) {
        <ul class="podium-alert-menu ft-dropdown-menu">
            <li><a (click)="replaceCurrent($event)">{{ tr('flipto.account.ReplaceCurrentPhoto') }}</a></li>
            <li><a (click)="bumpCurrentDown($event)">{{ tr('flipto.account.BumpCurrentPhoto') }}</a></li>
            <li><a (click)="swapWithCurrent($event)">Swap with current story</a></li>
        </ul>
    }
</div>
